import {
  NetworkEventData,
  RCEvent,
  EventName,
  EventType,
} from "../../core/eventhub/eventmodels.js";
import { EventController } from "../../core/eventhub/eventcontroller.js";
import { RidecellCallback } from "../../core/models/ridecellcallback.js";
import { CarsharingNetworkRequests } from "../networkrequestsbuilder.js";

export class StationController {
  /**
   * Gets the stations 
   *
   * market_id: required
   * rental_mode: The current customer profile mode
   * 
   * @returns List of all stations.
   */
  getStations(queryParams) {
    return new Promise((resolve, reject) => {
      const requestData = new NetworkEventData(
        EventType.GET,
        CarsharingNetworkRequests.stations,
        queryParams //queryData
      );

      const getStationsCallback = new RidecellCallback();
      getStationsCallback.onSuccess = (response) => {
        resolve(response.results);
      };

      getStationsCallback.onFailure = (error) => {
        reject(error);
      };
      this.sendEvent(
        new RCEvent(EventName.NETWORK, requestData, getStationsCallback)
      );
    });
  }

  sendEvent(event) {
    EventController.addEvent(event);
  }
}
